import { useQuery } from '@tanstack/react-query'
import { cmdbQuery, type DeviceCmdbPage } from '../api/devices'
import { moduleOf, shellQuery } from '../api/shell'
import { CmdbRecordFragment } from '../cmdb/CmdbRecordPage'
import { Spinner } from '../ui/Spinner'
import { usePageStyles } from '../ui/usePageStyles'
import type { ScreenProps } from './screens'

/**
 * Fila CMDB Relation - `Cmdb::deviceView`. Cand masina n-are inca CI, acelasi
 * alert-info ca in controller. Cand are, `renderCi(..., true)`: ACEEASI fisa
 * ca `/cmdb/view/{id}`, ca fragment - campurile clasei, ownership, provenienta,
 * costurile, telemetria, Connections, Impact, Tickets, History si Edit. Pana
 * acum fila avea o copie mai mica (doar relatiile, impactul si tichetele).
 */

const STYLES = ['css/adm.css']

export function DeviceCmdb({ id }: ScreenProps) {
  const shell = useQuery(shellQuery(moduleOf(typeof window === 'undefined' ? '' : window.location.pathname)))
  usePageStyles(STYLES, shell.data?.version ?? '')
  const { data, error } = useQuery(cmdbQuery(id))
  if (error) {
    return (
      <div className="alert alert-danger" role="alert">
        Something went wrong: {error.message}
      </div>
    )
  }
  if (!data) return <Spinner />
  return <Page page={data} />
}

function Page({ page }: { page: DeviceCmdbPage }) {
  if (page.empty || !page.ci) {
    return (
      <div className="alert alert-info" style={{ margin: 20 }}>
        <i className="fas fa-info-circle"></i> {page.message}
      </div>
    )
  }
  return <CmdbRecordFragment id={page.ci.id} />
}
